import { render, staticRenderFns } from "./OdontogramaTable.vue?vue&type=template&id=b6f6d646&"
import script from "./OdontogramaTable.vue?vue&type=script&lang=js&"
export * from "./OdontogramaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports